module.exports = __webpack_public_path__ + "img/noodles.33319373.png";